// extracted by mini-css-extract-plugin
module.exports = {"divider":"style-module__divider___n3cUj","details":"style-module__details___kHUn7","iFrame":"style-module__iFrame___urcEg","staticMap":"style-module__staticMap___G-Lh8"};